<template>
    <div>
        <label class="check-container">{{ label }}
            <input
                type="checkbox"
                :required="required"
                :checked="modelValue"
                @change="$emit('update:modelValue', $event.target.checked)"
            >
            <span
                class="trans checkmark rounded-lg border-gray100 flex items-center justify-center p-1 listing-search-input-container"
                style="width: 25px;"
            >
                <span
                    v-show="modelValue"
                    class="icon-s-check text-blue500"
                    style="position: relative; top: -1px;"
                ></span>
            </span>
        </label>
    </div>
</template>

<script>
// Checkbox used by listing and property search forms.
export default {
    props: {
        label: { type: String, default: '' },
        required: { type: Boolean, default: false },
        modelValue: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
};
</script>
